import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useState } from 'react';
import { DrawGeozones } from 'entities/map.geozone/ui/draw';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { ShowGeozoneRedactor } from 'entities/map.geozone/ui/show-redactor';
import { ShowGeozoneList } from 'entities/map.geozone/ui/show-list';
import branding from 'shared/app/model/branding';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { changeShowGeozoneRedactor, getShowGeozones, getShowGeozonesRedactor, } from 'entities/map.geozone/model/selectors';
import { is_paid_tariff, useShowPaidOptionsWithBalance, } from 'console/billing/billing-utils';
import { useIsFullscreen } from 'shared/map/ui/components/control-buttons/components/fullscreen/lib';
import { useAnchor } from 'shared/hooks/utils';
import { AdvertisementPopup } from 'entities/map.geozone/ui/advertisement-popup';
import { GeozoneListDialog } from 'entities/map.geozone/ui/list/dialog';
import { GeozonePropertiesDialog } from 'console/entities/map.geozone/ui/properties';
function selectMapDashboardEnabled(state) {
    if (branding.geozones_in_paid_tariff) {
        return is_paid_tariff(state);
    }
    return branding.geozones;
}
export const Geozones = memo(function Geozones(props) {
    const { show_geozones_buttons } = props;
    const show_geozones = useAppSelector(getShowGeozones);
    const show_geozones_redactor = useAppSelector(getShowGeozonesRedactor);
    const map_dashboard_enabled = useAppSelector(selectMapDashboardEnabled);
    const show_paid = useShowPaidOptionsWithBalance();
    const isFullScreen = useIsFullscreen();
    const [open_geozone_list, closeGeozoneList, openGeozoneList] = useBooleanState(false);
    const [open_geozone_properties, closeGeozoneProperties, openGeozoneProperties] = useBooleanState(false);
    const [selected_geozone, setSelectedGeozone] = useState(null);
    const [new_geozone, setNewGeozone] = useState(undefined);
    const onShowGeozoneProperties_ = useCallback((geozone_id, geozone) => {
        openGeozoneProperties();
        setSelectedGeozone(geozone_id);
        setNewGeozone(geozone);
    }, []);
    const onShowGeozoneProperties = useCallback((geozone_id, geozone) => setTimeout(() => onShowGeozoneProperties_(geozone_id, geozone), 0), [onShowGeozoneProperties_]);
    const onCloseGeozoneProperties = useCallback(() => {
        closeGeozoneProperties();
        setSelectedGeozone(null);
        setNewGeozone(undefined);
    }, []);
    const onWantShowGeozonesRedactor = useAction(changeShowGeozoneRedactor);
    const onShowGeozoneRedactor = useCallback(() => {
        onWantShowGeozonesRedactor(!show_geozones_redactor);
    }, [show_geozones_redactor, onWantShowGeozonesRedactor]);
    const show_geozone_button = useMemo(() => (branding.geozones ? show_geozones : show_paid && show_geozones) &&
        !isFullScreen, [show_geozones, isFullScreen, show_paid]);
    const [anchorElPro, onOpenPro, onClosePro] = useAnchor();
    return (_jsxs(_Fragment, { children: [_jsx(DrawGeozones, { onShowGeozoneProperties: onShowGeozoneProperties, show_geozones: show_geozones_buttons }), show_geozone_button && show_geozones_buttons && (_jsx(ShowGeozoneRedactor, { onClick: map_dashboard_enabled ? onShowGeozoneRedactor : onOpenPro })), show_geozone_button && show_geozones_buttons && (_jsx(ShowGeozoneList, { onClick: map_dashboard_enabled ? openGeozoneList : onOpenPro })), _jsx(GeozoneListDialog, { open: open_geozone_list, onCloseDialog: closeGeozoneList, openGeozoneProperties: onShowGeozoneProperties }), _jsx(GeozonePropertiesDialog, { open: open_geozone_properties, onCloseDialog: onCloseGeozoneProperties, geozone_id: selected_geozone, new_geozone: new_geozone }), _jsx(AdvertisementPopup, { anchorEl: anchorElPro, onClose: onClosePro })] }));
});
